import React from "react";
import {useHistory} from "react-router";

function NotFound (){

    let history = useHistory();

    const onClickBackPrevious = () => {
        history.push("/");
    };

    return (
        <div style={{ height: "100vh" }}>
            <div className="background-404">
                <div className="error-404-content-text px-4">
                 <h1>WE"RE SO SORRY, PAGE NOT FOUND!</h1>
                    <p>We're sorry, the page you requested could not be found. Please go back to the homepage.</p>
                    <a href="/" onClick={onClickBackPrevious}><b>Redirect to Homepage</b></a>
                </div>
            </div>
        </div>
    )
}

export default NotFound
